// extracted by mini-css-extract-plugin
export default {"tipsModalSubtitle":"DMvZQLlyuuW0uf50zxvt__tipsModalSubtitle___","tipsSection":"CoQnPIS8ftkhwKphgwhR__tipsSection___"};